import React from 'react';

export interface SnackProps {
  uid: string;
  type?: string;
  title?: string;
  text?: string;
  dismiss: (uid: string) => void;
  active: boolean;
  removed: boolean;
  timeout?: number | boolean;
}

export interface SnackState {
  timer: number | null;
}


class Snack extends React.Component<SnackProps, SnackState> {

  state: SnackState;


  constructor(props:SnackProps) {
    super(props);

    const defaultTimout = 8000;

    const timeout = (props.timeout || props.timeout !== false) ? window.setTimeout(() => {
      this.props.dismiss(this.props.uid);
    }, (props.timeout && props.timeout !== true) ? props.timeout : defaultTimout) : null;

    this.state = {
      timer: timeout,
    };

    this.dismiss = this.dismiss.bind(this);
  }


  render() {

    return (
      <div id={'Snack_'+this.props.uid} 
        className={'Snack' + (this.props.active ? ' active' : '') + (this.props.removed ? ' active-out' : '')}>

        <div className={"alert alert-"+(this.props.type)} role="alert">
          <button type="button" className="close" aria-label="Close"
            onClick={this.dismiss}><span aria-hidden="true">&times;</span></button>
          {this.props.title ? (<h5 className="title">{this.props.title}</h5>) : ''}
          {this.props.text ? (<p className="text">{this.props.text}</p>) : ''}
        </div>
      </div>
    );
  }


  dismiss(e: React.MouseEvent) {
    e.preventDefault();

    if (this.state.timer) {
      window.clearTimeout(this.state.timer);
    }
    
    return this.props.dismiss(this.props.uid);
  }

}


export default Snack;
